import { useCallback, useEffect, useState } from "react";

import { testsService } from "@/services/tests";
import { LightweightTransparentCareRecommendations } from "@/types/care";

export const useLightweightTransparentCareTreatments = (testHash?: string) => {
  const [data, setData] = useState<LightweightTransparentCareRecommendations>();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [refetch, setRefetch] = useState(false);

  const fetchLightweightTransparentCareTreatments = useCallback(async () => {
    if (testHash) {
      setIsLoading(true);
      try {
        const response =
          await testsService.fetchTestLightweightTransparentCareRecommendations(
            testHash
          );
        setData(response.data);
      } catch (error: any) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    }
  }, [testHash]);

  useEffect(() => {
    if (testHash) {
      fetchLightweightTransparentCareTreatments();
    }
  }, [testHash, fetchLightweightTransparentCareTreatments, refetch]);

  const refetchLightweightTransparentCareTreatments = () => {
    setRefetch((prev) => !prev);
  };

  return {
    lightweightTransparentCareTreatments: data,
    error,
    isLoading,
    refetchLightweightTransparentCareTreatments,
  };
};
